import React from "react"
import * as helpers from "../../helpers/sectionclasses"
import VimeoPlyrEmbed from "../vimeoplyrembed"

const VimeoEmbed = ({ content }) => {
  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  
  return (
    <section className={`vimeo-embed ${sectionClasses}`}>
      <div className="container px-0 lrg:px-4">
        <div className="lrg:px-6">
          <VimeoPlyrEmbed
            label={content.label}
            title={content.title}
            textAlign={content.textAlign}
            source={content.vimeoId}
            posterGif={(content.cloudinaryPosterAnim) ? true : false}
            posterGifSource={content.cloudinaryPosterAnim}
            reverseLabelOrder={content.reverseLabelOrder}
            />
        </div>
      </div>
    </section>
  )
}

export default VimeoEmbed
